import { noop } from "lodash-es";
import { createContext, use } from "react";

export const ModalContext = createContext<{ closeModal: () => void }>({
  closeModal: noop,
});

export const useModal = () => use(ModalContext);
